import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var DocumentationIcon = function DocumentationIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "DocumentationIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1 2.325c0-.455.369-.825.824-.825h3.705A3.27 3.27 0 0 1 8 2.633q.067-.076.136-.147a3.27 3.27 0 0 1 2.335-.986h3.706c.454 0 .823.37.823.825v9.458a.824.824 0 0 1-.823.825H9.853c-.268 0-.528.109-.723.307a1.09 1.09 0 0 0-.306.76.824.824 0 1 1-1.648 0c0-.288-.112-.56-.306-.76a1 1 0 0 0-.723-.306H1.824A.825.825 0 0 1 1 11.782zm6.176 8.842a2.6 2.6 0 0 0-1.029-.21h-3.5V3.152H5.53c.432 0 .85.175 1.16.491.31.317.487.75.487 1.205zm1.648 0a2.6 2.6 0 0 1 1.029-.21h3.5V3.152H10.47c-.432 0-.85.175-1.16.491-.31.317-.487.75-.487 1.205z",
      clipRule: "evenodd"
    })
  }));
};

export { DocumentationIcon };
